import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'replaceComma',
    standalone: false
})
export class ReplaceCommaPipe implements PipeTransform {
  transform(value: any): any {
    return value ? value.toString().replace(/,/g, ' ') : value;
  }
}
